import styled from "styled-components";
import { Tag, Button } from "antd";
import {
  PRIMARY_600,
  PRIMARY_800,
  SUCCESS_100,
  SUCCESS_900,
  GRAY_100,
  GRAY_300,
  GRAY_500,
  BLACK,
  WHITE,
  PRIMARY_200,
  GRAY_600,
  GRAY_200
} from "../../../constant/colors";

export const Section = styled.div`
  margin-bottom: 4px;
`;

export const SectionTitle = styled.h2`
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 700;
  color: ${PRIMARY_600};
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 16px;

  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background-color: ${PRIMARY_600};
  }
`;

export const StatusTag = styled(Tag)`
  border-radius: 12px;
  padding: ${(props) => props.padding || "4px 12px"};
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  border: none;

  &.active-tag {
    background-color: ${SUCCESS_100};
    color: ${SUCCESS_900};
  }

  &.inactive-tag {
    background-color: ${GRAY_100};
    color: ${GRAY_500};
  }
`;

// Breadcrumb Components
export const BreadcrumbSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 8px;
`;

export const BreadcrumbLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const BreadcrumbItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  color: ${BLACK};
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: ${PRIMARY_600};
  }
`;

export const BreadcrumbSeparator = styled.span`
  color: ${GRAY_500};
  font-size: 16px;
  &:before {
    content: ">";
  }
`;

export const BreadcrumbCurrent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  color: ${BLACK};

  svg {
    width: 16px;
    height: 16px;
  }
`;

// Button Components
export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const StyledButton = styled(Button)`
  height: 40px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 8px;

  &:disabled,
  &[disabled] {
    background-color: ${GRAY_300} !important;
    color: ${WHITE} !important;
    border: none !important;
    box-shadow: none !important;
    cursor: not-allowed;
    opacity: 1 !important;
  }

  &:disabled:hover,
  &[disabled]:hover {
    background-color: ${GRAY_300} !important;
    color: ${WHITE} !important;
    border: none !important;
  }
`;

export const StyledActionButton = styled(Button)`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: ${PRIMARY_600} !important;

  &:hover {
    background-color: ${PRIMARY_800} !important;
  }

  &:focus {
    border: 0 !important;
    box-shadow: 0 0 0 4px ${PRIMARY_200};
  }

  &:disabled {
    background-color: ${GRAY_300} !important;
  }
`;

export const StyledActionButtonNoClick = styled(StyledActionButton)`
  cursor: default;

  &:focus {
    border: none !important;
    box-shadow: none !important;
  }
`;

export const StyledPrimaryButton = styled(StyledButton)`
  background-color: ${PRIMARY_600} !important;

  &:hover {
    background-color: ${PRIMARY_800} !important;
  }

  &:focus {
    border: 0 !important;
    box-shadow: 0 0 0 4px ${PRIMARY_200};
  }

  &:disabled {
    background-color: ${GRAY_300} !important;
  }

  &:hover {
    background-color: ${PRIMARY_800} !important;
  }

  &:focus {
    border: 0 !important;
    box-shadow: 0 0 0 4px ${PRIMARY_200};
  }

  &:disabled {
    background-color: ${GRAY_300} !important;
  }
`;

export const StyledSecondaryButton = styled(StyledButton)`
  background-color: ${WHITE} !important;
  color: ${BLACK} !important;
  border: 1px solid ${GRAY_300} !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;

  &:hover {
    border: 1px solid ${BLACK} !important;
  }

  &:focus {
    border: 1px solid ${GRAY_600} !important;
    box-shadow: 0 0 0 4px ${GRAY_200};
  }
`;

export const CancelButton = styled(Button)`
  height: 40px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  border: none !important;
  background: transparent !important;
  color: ${BLACK} !important;
  box-shadow: none !important;

  &:hover,
  &:focus {
    background: transparent !important;
    color: ${BLACK} !important;
    border: none !important;
    box-shadow: none !important;
  }

  & > span {
    border-bottom: 1px solid ${BLACK};
    padding-bottom: 5px;
    display: inline-block;
  }
`;

export const MetaText = styled.div`
  font-size: 14px;
  margin-bottom: 16px;
`;

export const CreatedText = styled.span`
  color: ${GRAY_500};
`;

export const UpdatedText = styled.span`
  color: ${BLACK};
  margin-left: 16px;
`;
